import { render, staticRenderFns } from "./subcribe.vue?vue&type=template&id=03c88a0a&scoped=true"
import script from "./subcribe.vue?vue&type=script&lang=js"
export * from "./subcribe.vue?vue&type=script&lang=js"
import style0 from "./subcribe.vue?vue&type=style&index=0&id=03c88a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c88a0a",
  null
  
)

export default component.exports